import { lazyAppContext } from '../lazy';
import { JsonParser } from './storage.manager';
export class TtlMapStorage {
    constructor(key, expireFnOrTime) {
        this.key = key;
        this.expireFnOrTime = expireFnOrTime;
        this.context = lazyAppContext('TtlMapStorage');
        this.lastUpdateTimestampMap = new Map();
    }
    async init(context) {
        this.context.set(context);
        const state = this.context.value.storage.get(this.key, JsonParser);
        this.lastUpdateTimestampMap = new Map(state ?? []);
    }
    reset(key) {
        const timestamp = Date.now();
        this.lastUpdateTimestampMap.set(key, timestamp);
        this.context.value.storage.set(this.key, [...this.lastUpdateTimestampMap.entries()]);
    }
    isExpired(key, props) {
        const expire = typeof this.expireFnOrTime === 'function'
            ? this.expireFnOrTime(props)
            : this.expireFnOrTime;
        const lastUpdateTimestamp = this.lastUpdateTimestampMap.get(key);
        if (!lastUpdateTimestamp)
            return true;
        return Date.now() - lastUpdateTimestamp > expire;
    }
}
//# sourceMappingURL=ttl-map.storage.js.map